export default {
  titleLineHeight: '1.3'
}
